<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-toolbar class="headline" color="primary" dark>{{ title }}</v-toolbar>
        <v-card-text>
          <v-form ref="SimpleDialogForm" v-model="valid" lazy-validation>
            <v-container>

              <v-col cols="50">
                <v-text-field :disabled="!addFlg"
                              label="ユーザ名"
                              v-model="user_id"
                              :counter="10"
                              :maxlength="10"
                              :rules="userIDRules"
                              required
                              prepend-icon="mdi-account-circle"></v-text-field>
              </v-col>

              <v-col> </v-col>
            <v-col cols="50">
              8文字以上、英字（大小）、数字、記号（_?!#$%&）を含めて設定必須
            </v-col>
              <v-col cols="50">
                <v-text-field v-if="!addFlg"
                              label="現在のパスワード"
                              v-model="oldPassword"
                              :counter="20"
                              :maxlength="20"
                              :rules="passwordRules"
                              required
                              v-bind:type="showOldPassword ? 'text':'password'"
                              v-bind:append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                              prepend-icon="mdi-lock"
                              @click:append="showOldPassword=!showOldPassword"></v-text-field>
              </v-col>
              <v-col cols="50">
                <v-text-field label="新しいパスワード"
                              v-model="newPassword"
                              :counter="20"
                              :maxlength="20"
                              :rules="passwordRules"
                              required
                              v-bind:type="showNewPassword ? 'text':'password'"
                              v-bind:append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                              prepend-icon="mdi-lock"
                              @click:append="showNewPassword=!showNewPassword"></v-text-field>
              </v-col>
              <v-col cols="50">
                <v-text-field label="もう一度入力"
                              v-model="confPassword"
                              :counter="20"
                              :maxlength="20"
                              :rules="passwordRules"
                              required
                              v-bind:type="showConfPassword ? 'text':'password'"
                              v-bind:append-icon="showConfPassword ? 'mdi-eye' : 'mdi-eye-off'"
                              prepend-icon="mdi-lock"
                              @click:append="showConfPassword=!showConfPassword"></v-text-field>
              </v-col>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'設定'" :handlerClick="handleOkConfirm"></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-dialog>
  </v-row>
</template>

<script>
  import { RyouTableMixins } from "@/mixins/RyouTableMixins";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

  export default {
    components: {
      RyouBlackBtn,
      RyouConfirm
    },
  mixins: [RyouTableMixins],
  mounted() {
    this.userIDRules.push(this.GlobalRules.required);
    this.userIDRules.push(this.GlobalRules.number3);
    this.passwordRules.push(this.GlobalRules.required);
    this.passwordRules.push(this.GlobalRules.hanSpec);
    this.passwordRules.push(this.GlobalRules.more_8);
    this.passwordRules.push(this.GlobalRules.required_lowercase);
    this.passwordRules.push(this.GlobalRules.required_uppercase);
    this.passwordRules.push(this.GlobalRules.required_number);
    this.passwordRules.push(this.GlobalRules.required_spec);
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    dialog: false,
    valid: true,
    addFlg : true,
    title: "",
    user_id: "",
    oldPassword: "",
    newPassword: "",
    confPassword: "",
    showOldPassword: false,
    showNewPassword: false,
    showConfPassword: false,
    userIDRules: [],
    passwordRules: [],
    rowKey: "rowIndex",
    businessKey: "user_id",
  }),
  methods: {
    add() {
      this.open();
      this.title = "利用者登録";
      this.addFlg = true;
    },
    edit(record) { 
      this.open();
      this.user_id = record.user_id
      this.title = "パスワード変更";
      this.addFlg = false;
      setTimeout(() => {
        this.model = Object.assign({}, record);
      }, 10);
    },
    handleOkConfirm() {
      var valid = this.$refs.SimpleDialogForm.validate();
      if (valid) {
        this.$refs.confirm.open("登録", "登録します。宜しいですか？", { color: "info" }).then((confirm) => {
          if (confirm) {
            this.handleOk();
          }
        });
      }
    },
    handleOk() {
      var valid = this.$refs.SimpleDialogForm.validate();
      if (valid) {
        var that = this;
        if (this.addFlg) {
          let params = {
            user_id : this.user_id,
            password: this.newPassword,
            conf_password: this.confPassword,
            reg_user_id: this.$store.getters.getUserId,
            upd_user_id: this.$store.getters.getUserId
          };
            this.postRequest(this.url.add, params, this.$store.getters.getUserToken).then(resp => {
            if (resp.success) {
              that.$emit("ok");
              that.close();
            }
            
          });
        } else {
          let params = {
            user_id : this.user_id,
            old_password : this.oldPassword,
            new_password: this.newPassword,
            conf_password: this.confPassword,
            reg_user_id: this.$store.getters.getUserId,

          };
            this.putRequest(this.url.update, params, this.$store.getters.getUserToken).then(resp => {
            if (resp.success) {
              that.$emit("ok");
              that.close();
            }
            
          });
        }
      }

    },
    handleCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      this.user_id = "";
    },
    open() {
      this.dialog = true;

      if (this.$refs.SimpleDialogForm) {
        this.$refs.SimpleDialogForm.reset();
        this.$refs.SimpleDialogForm.resetValidation();
      }
    }
  }
};
</script>

<style>
</style>
